var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrendUpArrow = function SvgTrendUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6224 6.5H16.9974M16.9974 6.5V10.8748M16.9974 6.5L10.9134 12.1498C10.8128 12.2414 10.6775 12.2927 10.5365 12.2927C10.3956 12.2927 10.2602 12.2414 10.1596 12.1498L7.68266 9.84988C7.58201 9.75827 7.44668 9.70695 7.30574 9.70695C7.1648 9.70695 7.02947 9.75827 6.92882 9.84988L2.99805 13.4997",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTrendUpArrow;